import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ClientMeldingenComponent} from './client-meldingen/client-meldingen.component';

@NgModule({
  declarations: [
    ClientMeldingenComponent,
  ],
  imports: [
    CoreModule,
  ],
  exports: [
    ClientMeldingenComponent,
  ],
})
export class ClientMeldingModule {
}
